export const GET_LIST = 'getList'
export const SET_LIST = 'setList'
export const CREATE = 'create'
export const CREATED = 'created'
export const SET_LOADING = 'setLoading'
